<template>
  <h-msg-box
    v-model="showModal"
    width="480"
    class="financial-competition-modal"
    :mask-closable="false"
  >
    <p slot="header">
      <span class="model-header">{{ headerTitle }}</span>
    </p>
    <div>
      <div class="team-name" v-if="type === 'success'">
        恭喜你成功加入
        <span>{{ teamInfo.team_name || '-' }}</span>
        战队，一起努力吧！
      </div>
      <div class="team-name" v-else>
        很抱歉
        <span>{{ teamInfo.team_name || '-' }}战队已满员</span>
        请跟队长再次确认
      </div>
      <h-description :column="1">
        <h-description-item label="当前队员" :contextWrap="false">
          <span
            class="team-items"
            v-if="teamInfo.team_members && teamInfo.team_members.length !== 0"
          >
            <h-tooltip
              class="mate-item"
              placement="top"
              v-for="(item, index) in teamInfo.team_members"
              :key="item.emp_name"
            >
              <span :class="['mate-name', 'mate-' + index]">
                <span class="captain-tag" v-if="item.captain"
                  ><span>队长</span></span
                >
                {{ item.emp_name.substr(-2) }}</span
              >
              <div slot="content">
                <p style="color: #fff">{{ item.emp_name }}</p>
                <p style="color: #fff">{{ item.emp_id }}</p>
                <p style="color: #fff">{{ item.emp_post }}</p>
              </div>
            </h-tooltip>
          </span>
        </h-description-item>
      </h-description>
    </div>
    <div slot="footer">
      <comp-button class="btn-icon" @click="showModal = false"
        >知道了</comp-button
      >
    </div>
  </h-msg-box>
</template>

<script>
import { CompButton } from '../common'
import { HDescription, HDescriptionItem } from '@/components/HDescription'
import { mapGetters } from 'vuex'

export default {
  name: 'JoinInviteTeam',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'success'
    }
  },
  data() {
    return {
      showModal: false,
      headerTitle: ''
    }
  },
  components: {
    CompButton,
    HDescription,
    HDescriptionItem
  },
  computed: {
    ...mapGetters(['teamInfo'])
  },
  created() {
    this.showModal = this.value
  },
  watch: {
    value(newValue, oldValue) {
      this.showModal = newValue
      this.headerTitle = this.type === 'fail' ? '组队失败' : '组队成功'
    },
    showModal(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.model-header {
  font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.team-items {
  .mate-item {
    display: inline-block;
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    position: relative;
    margin-right: 10px;
    margin-top: 5px;
    .mate-name {
      position: relative;
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei', sans-serif,
        Verdana, 'PingFang SC';
      font-size: 14px;
      color: #fff;
      cursor: pointer;
      white-space: nowrap;
      // overflow: hidden;
      text-overflow: ellipsis;
      &.mate-0 {
        background: #3060ff;
      }
      &.mate-1 {
        background: #1cb77b;
      }
      &.mate-2 {
        background: #ff791a;
      }
      &.mate-3 {
        background: #006600;
      }
      &.mate-4 {
        background: #993399;
      }
    }
    .captain-tag {
      position: absolute;
      width: 24px;
      height: 24px;
      background: url('~@/assets/financialCompetition/captain_bg.png')
        center/contain no-repeat;
      right: -4px;
      top: -9px;
      font-size: 12px;
      color: #fff;
      font-weight: 400;
      line-height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        display: inline-block;
        transform-origin: center;
        transform: scale(0.5);
      }
    }
  }
}
.team-name {
  font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 14px;
  color: #333333;
  text-align: left;
  line-height: 32px;
  margin: 0 0 24px 80px;
  span {
    color: #f2b044;
    margin-right: 5px;
  }
}
</style>







// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/TeamInvite/JoinInviteTeam.vue